export default "__VITE_ASSET__D9a_OYFx__"